/**
 * @fileoverview Dialogs - Provides various helper dialogs for the social post box
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.provide('yext.social.post.dialogs');
goog.provide('yext.social.post.dialogs.MissingAccountsDialog');
goog.provide('yext.social.post.dialogs.MissingPermissionsDialog');
goog.provide('yext.social.post.dialogs.MissingFieldsDialog');
goog.provide('yext.social.post.dialogs.NoLinkedAccountDialog');
goog.provide('yext.social.post.dialogs.SuccessDialog');

goog.require('yext');

yext.social.post.dialogs.DEFAULT_OPTS = {
  autoOpen: false,
  modal: true,
  draggable: false,
  resizable: false,
  width: 600,
};

/** @constructor */
yext.social.post.dialogs.MissingAccountsDialog = function(onConfirmPost, onCancelPost) {
  this.$el = $('#missing-accounts-dialog');

  this.onConfirmPost_ = onConfirmPost;

  this.onCancelPost_ = onCancelPost;
};

/** @suppress {deprecated} */
yext.social.post.dialogs.MissingAccountsDialog.prototype.init = function() {
  this.$el.dialog($.extend({}, yext.social.post.dialogs.DEFAULT_OPTS, {
    // TRANSLATOR: Lacking connected social accounts
    title: yext.msg('Missing linked accounts'),
  }));

  this.$el.find('.cancel').on('click', function(e) {
    e.stopPropagation();
    this.$el.dialog('close');
    this.onCancelPost_();
  }.bind(this));

  this.$el.find('.primary').on('click', function(e) {
    e.stopPropagation();
    this.$el.dialog('close');
    this.onConfirmPost_($.extend(this.$el.data('opts'), {force: true}));
  }.bind(this));

  return this;
};

yext.social.post.dialogs.MissingAccountsDialog.prototype.open = function(data, opts) {
  var n = data['linkedAccounts'];
  // TRANSLATORS: Arguments are numbers.
  var errorMsg1 = yext.msgn(
    'Your selected location does not have a linked account associated with it. ' +
        'We will not be able to create posts for this location.',
    '{0} of your selected locations do not have a linked account associated with them. ' +
        'We will not be able to create posts for these locations.',
    data['missingAccounts']);
  var errorMsg2 = yext.msgn(
    'You will be posting to 1 location. Proceed anyway?',
    'You will be posting to {0} locations. Proceed anyway?',
    n);
  this.$el.find('.missing-accounts-dialog-msg').text(errorMsg1 + ' ' + errorMsg2);
  this.$el.data('opts', opts || {}).dialog('open');
};

/** @constructor */
yext.social.post.dialogs.MissingPermissionsDialog = function(onConfirmPost, onCancelPost) {
  this.$el = $('#missing-permissions-dialog');

  this.onConfirmPost_ = onConfirmPost;

  this.onCancelPost_ = onCancelPost;
};

/** @suppress {deprecated} */
yext.social.post.dialogs.MissingPermissionsDialog.prototype.init = function() {
  this.$el.dialog($.extend({}, yext.social.post.dialogs.DEFAULT_OPTS, {
    // TRANSLATORS: missing means lacking
    title: yext.msg('Missing permissions'),
  }));

  this.$el.find('.cancel').on('click', function(e) {
    e.stopPropagation();
    this.$el.dialog('close');
    this.onCancelPost_();
  }.bind(this));

  this.$el.find('.primary').on('click', function(e) {
    e.stopPropagation();
    this.$el.dialog('close');
    this.onConfirmPost_($.extend(this.$el.data('opts'), {permissionsForce: true}));
  }.bind(this));

  return this;
};

yext.social.post.dialogs.MissingPermissionsDialog.prototype.open = function(data, opts) {
  this.$el.find('.missing-permissions-count').text(data['missingPermissions']);
  var missing = data['missingPermissions'];
  var total = data['businessLocations'];
  var posting = data['locations'];
  // TRANSLATORS: Arguments are numbers.
  var errorMsg1 = yext.msgn(
    'You are missing the permission to create posts for the location in this account.',
    'You are missing the permission to create posts for {1} of the {0} locations in this account.',
    total, missing);
  var errorMsg2 = yext.msgn(
    'We will not be able to create posts for this location.',
    'We will not be able to create posts for these locations.',
    missing);
  var errorMsg3 = yext.msgn(
    'You will be posting to 1 location. Proceed anyway?',
    'You will be posting to {0} locations. Proceed anyway?',
    posting);
  this.$el.find('.missing-permissions-dialog-msg')
    .text(errorMsg1 + ' ' + errorMsg2 + ' ' + errorMsg3)
    .data('opts', opts || {})
    .dialog('open');
};

/** @constructor */
yext.social.post.dialogs.MissingFieldsDialog = function(onConfirmPost, onCancelPost) {
  this.$el = $('#missing-fields-dialog');

  this.onConfirmPost_ = onConfirmPost;

  this.onCancelPost_ = onCancelPost;
};

/** @suppress {deprecated} */
yext.social.post.dialogs.MissingFieldsDialog.prototype.init = function() {
  this.$el.dialog($.extend({}, yext.social.post.dialogs.DEFAULT_OPTS, {
    // TRANSLATORS: missing means lacking
    title: yext.msg('Missing fields'),
    width: 450,
  }));

  this.$el.find('.cancel').on('click', function(e) {
    e.stopPropagation();
    this.onCancelPost_();
    this.$el.dialog('close');
  }.bind(this));

  this.$el.find('.fb-post-all').on('click', function(e) {
    e.stopPropagation();
    this.$el.dialog('close');
    this.onConfirmPost_($.extend(this.$el.data('opts'), {emptyForce: true}));
  }.bind(this));

  this.$el.find('.fb-skip-missing').on('click', function(e) {
    e.stopPropagation();
    this.$el.dialog('close');
    this.onConfirmPost_($.extend(this.$el.data('opts'), {emptySkip: true}));
  }.bind(this));

  return this;
};

yext.social.post.dialogs.MissingFieldsDialog.prototype.open = function(data, opts) {
  var n = data['locations'];
  // TRANSLATORS: Arguments are numbers.
  var errorMsgMultiple = yext.msgn(
    'Your selected location is missing content for one or more of the following fields you specified in your post:',
    '{0} locations are missing content for one or more of the following fields you specified in your post:',
    data['emptyCount']);
  this.$el.find('.missing-fields-dialog-msg').text(errorMsgMultiple);
  this.$el.find('.fb-multiple').toggle(n > 1);
  this.$el.find('.fb-single').toggle(n == 1);

  var $ul = this.$el.find('ul');
  $ul.empty();
  $.each(data['emptyFields'], function(i, field) {
    $('<li/>').text(field).appendTo($ul);
  });

  var allMissing = data['emptyCount'] >= n;
  this.$el.find('.all-missing').toggle(allMissing);
  this.$el.find('.partial-missing').toggle(!allMissing);
  this.$el.find('.fb-skip-missing').toggle(!allMissing);
  this.$el.find('.fb-post-all span').text(allMissing ? 'Post' : 'Post to All');
  this.$el.find('.fb-post-all')
    .toggleClass('button-orange', allMissing)
    .toggleClass('button-cancel', !allMissing);
  this.$el.data('opts', opts || {}).dialog('open');
};

/** @constructor */
yext.social.post.dialogs.NoLinkedAccountDialog = function(onCancelPost) {
  this.$el = $('#link-accounts-dialog');

  this.onCancelPost_ = onCancelPost;
};

/** @suppress {deprecated} */
yext.social.post.dialogs.NoLinkedAccountDialog.prototype.init = function() {
  this.$el.dialog($.extend({}, yext.social.post.dialogs.DEFAULT_OPTS, {
    title: yext.msg('No linked account'),
  }));
  this.$el.find('.cancel').on('click', function(e) {
    e.stopPropagation();
    this.onCancelPost_();
    this.$el.dialog('close');
  }.bind(this));

  return this;
};

/** @suppress {deprecated} */
yext.social.post.dialogs.NoLinkedAccountDialog.prototype.open = function() {
  this.$el.dialog('open');
};

/** @constructor */
yext.social.post.dialogs.SuccessDialog = function() {
  this.$el = $('#post-success-dialog');
};

/** @suppress {deprecated} */
yext.social.post.dialogs.SuccessDialog.prototype.init = function() {
  this.$el.dialog($.extend({}, yext.social.post.dialogs.DEFAULT_OPTS, {
    // TRANSLATORS: "Wall" means "Facebook wall/timeline"
    title: yext.msg('Wall post created!'), // default Title
    width: 350,
    open: function(e) {
      var $target = $(e.target);
      if ($target.data('requires-approval')) {
        $target.find('.js-post-success-message').hide();
        $target.find('.js-submit-for-approval-message').show();
        this.$el.dialog('option', 'title', 'Post Submitted!');
      } else {
        $target.find('.js-submit-for-approval-message').hide();
        $target.find('.js-post-success-message').show();
      }
    }.bind(this),
  }));
  this.$el.find('.primary').on('click', function(e) {
    e.stopPropagation();
    this.$el.dialog('close');
  }.bind(this));

  return this;
};

/** @suppress {deprecated} */
yext.social.post.dialogs.SuccessDialog.prototype.open = function(data) {
  this.$el.find('.partial-error').toggle(data.failCount > 0);
  this.$el.find('.post-error-count')
    .text(data.failCount + ' post' + (data.failCount > 1 ? 's' : ''));
  this.$el.find('.reauth-error').toggle(data.reauth > 0);
  this.$el.find('.reauth-button').toggle(data.reauth > 0);
  this.$el.data('requires-approval', data.requiresApproval);
  this.$el.dialog('open');
};
